export const POTTSALAT_PAYMENT = {
    MONDU_INVOICE: "pottsalat_mondu_invoice",
    MONDU_DIRECT_DEBIT: "pottsalat_mondu_direct_debit",
    PAYPAL: "pottsalat_paypal",
    COMPUTOP_CREDITCARD: "pottsalat_computop_creditcard",
    COMPUTOP_SOFORT: "pottsalat_computop_sofort",
    COMPUTOP_PAYDIREKT: "pottsalat_computop_paydirekt",
    NONE: "none",
};

export default [
    {
        value: POTTSALAT_PAYMENT.MONDU_INVOICE,
        heading: "paymentSelect.monduInvoiceHeading",
        text: "paymentSelect.monduInvoiceText",
        appendLinkUrl:
            "https://www.mondu.ai/de/datenschutzgrundverordnung-kaeufer/",
        appendLinkText: "paymentSelect.monduAppendLinkText",
        icons: ["mondu.png"],
    },
    {
        value: POTTSALAT_PAYMENT.MONDU_DIRECT_DEBIT,
        heading: "paymentSelect.monduDirectDebitHeading",
        text: "paymentSelect.monduDirectDebitText",
        appendLinkUrl:
            "https://www.mondu.ai/de/datenschutzgrundverordnung-kaeufer/",
        appendLinkText: "paymentSelect.monduAppendLinkText",
        icons: ["mondu.png"],
    },
    {
        value: POTTSALAT_PAYMENT.COMPUTOP_CREDITCARD,
        heading: "paymentSelect.creditCardHeading",
        text: "paymentSelect.creditCardText",
        icons: ["visa.png", "mastercard.png"],
    },
    {
        value: POTTSALAT_PAYMENT.COMPUTOP_SOFORT,
        heading: "paymentSelect.klarnaHeading",
        text: "paymentSelect.klarnaText",
        icons: ["klarna.png"],
    },
    {
        value: POTTSALAT_PAYMENT.COMPUTOP_PAYDIREKT,
        heading: "paymentSelect.payDirektHeading",
        text: "paymentSelect.payDirektText",
        icons: ["paydirekt.png"],
    },
    {
        value: POTTSALAT_PAYMENT.PAYPAL,
        heading: "paymentSelect.paypalHeading",
        text: "paymentSelect.paypalText",
        icons: ["paypal.png"],
    },
];
